export default __webpack_public_path__ + "static/media/newsletter.f5c2c1aa.png";